import { render } from "./sign.svg?vue&type=template&id=9556076e"
const script = {}
script.render = render

export default script